var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeclineInvite = function SvgDeclineInvite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "DeclineInvite_svg__a",
    width: 36,
    height: 36,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#272727",
    mask: "url(#DeclineInvite_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m12 12 12 12m0-12L12 24"
  }))));
};
export default SvgDeclineInvite;